export const TYPE_ID = {
  SUMMARY: 7,
};
